import get from 'lodash/get';
import type {DataValue} from '../types';

export const evaluatePropValue = (
  path: string,
  value?: DataValue,
): DataValue => {
  return get(value, path) ?? null;
};
